import {
  GET_SER_DEVICE_LIST_REQUEST,
  GET_SER_DEVICE_LIST_SUCCESS,
  GET_SER_DEVICE_LIST_ERROR,
  CHECK_STOCK_AVAILABILITY_REQUEST,
  CHECK_STOCK_AVAILABILITY_SUCCESS,
  CHECK_STOCK_AVAILABILITY_ERROR
} from '@/actions/serroadshow/actionTypes';

export const initialState = {
  isLoading: false,
  serDeviceListsData: [],
  serSvcNoListsData: [],
  serDeviceListError: '',
  equipStockData: [],
  stockAvailabilityError: '',
  serAddressDetail: []
};

const serRoadshowReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SER_DEVICE_LIST_REQUEST:
    case CHECK_STOCK_AVAILABILITY_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_SER_DEVICE_LIST_SUCCESS: {
      const { equipmentList, simList, addressDetail } = action.data
      return {
        ...state,
        isLoading: false,
        serDeviceListsData: equipmentList,
        serSvcNoListsData: simList,
        serAddressDetail: addressDetail
      };
    }
    case CHECK_STOCK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        equipStockData: action.data
      };
    case GET_SER_DEVICE_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        serDeviceListError: action.error.response?.data?.message
      };
    case CHECK_STOCK_AVAILABILITY_ERROR:
      return {
        ...state,
        isLoading: false,
        stockAvailabilityError: action.error.response?.data?.message
      };
    default:
      return state;
  }
};

export default serRoadshowReducer;
